import { MobileLiveSectorDisplay } from "./MobileLiveSectorDisplay";
export default MobileLiveSectorDisplay;
